<div>
  <span class="text-slice"
        #textContent
        [class.text-clamped]="!expand"
        [style.-webkit-line-clamp]="!expand ? lines : null"
        [innerHTML]="text">
  </span>

  <span class="text-slice-show-more cursor-pointer text-blue-2"
        data-modal-ignore
        *ngIf="!expand && isOverflow"
        (click)="showMore()">
    <span>{{'common.textSlice.readMore' | translate}}</span>
  </span>

  <span class="text-slice-show-more cursor-pointer text-blue-2"
        data-modal-ignore
        *ngIf="expand && isOverflow"
        (click)="showLess()">
    <span>{{'common.textSlice.hide' | translate}}</span>
  </span>
</div>
